import { contactCard } from './contactCard';

export const appraiserContactCard = contactCard(
  'additionalContacts.appraiser',
  'appraiser',
);
